import React from "react";
import "./star-rating.css";
import StarIcon from "@mui/icons-material/Star";

const StarRating = ({ rating = 0 }) => {
  const rate = parseInt(rating ?? 0);

  if (rate <= 0) return null;

  return (
    <div className="property-star-rating">
      {[...Array(parseInt(rate))].map((x, i) => (
        <StarIcon key={i} style={{ color: "#fac917" }} fontSize="small" />
      ))}
    </div>
  );
};

export default StarRating;
